export default __webpack_public_path__ + "static/media/Card-LatitudeLowRateMastercard.d2ac6881.png";